/**
 * This file is part of vue-boilerplate.
 * @link     : https://zhaiyiming.com/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 TINYMINS.
 */
import { RouteConfig } from 'vue-router';
import { AUTH_STATE } from '@/config';
import { isInDevMode } from '@/utils/environment';

export default [
  {
    name: 'user',
    path: '/user',
    meta: { tabbar: 'secret/user' },
    components: {
      static: () => import('@/views/common/static'),
      header: () => import('@/views/common/header'),
      main: () => import('@/views/common/main'),
      footer: () => import('@/views/common/footer'),
    },
    redirect: { name: 'user_me' },
    children: [
      {
        name: 'user_login',
        path: 'login',
        component: () => import('@/views/common/main'),
        redirect: { name: 'user_login_index' },
        children: [
          {
            name: 'user_login_index',
            path: '',
            meta: { auth: AUTH_STATE.GUEST, title: '登录' },
            component: () => import('@/views/user/login'),
          },
          isInDevMode()
            ? {
              name: 'user_login_dev',
              path: 'dev',
              meta: { title: '开发登录' },
              component: () => import('@/views/user/login_dev'),
            }
            : null,
        ].filter(_ => _),
      },
      {
        name: 'user_switch',
        path: 'switch',
        meta: { auth: [AUTH_STATE.LOGGED_IN, AUTH_STATE.UNAVAILABLE], title: '微信与换号' },
        component: () => import('@/views/user/switch'),
      },
      {
        name: 'user_register',
        path: 'register',
        meta: { auth: [AUTH_STATE.LOGGED_IN, AUTH_STATE.UNREGISTERED], title: '加入海鳗' },
        component: () => import('@/views/user/register'),
      },
      {
        name: 'user_register_phone',
        path: 'register/phone',
        meta: { auth: [AUTH_STATE.LOGGED_IN, AUTH_STATE.UNAVAILABLE, AUTH_STATE.UNREGISTERED], title: '创建用户' },
        component: () => import('@/views/user/register_phone'),
      },
      {
        name: 'user_me',
        path: 'page/me',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '我的' },
        component: () => import('@/views/user/me'),
      },
      {
        name: 'user_other',
        path: 'others/:id',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '他人主页' },
        component: () => import('@/views/user/other'),
      },
      {
        name: 'profile_report',
        path: 'others/:id/report',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '举报' },
        component: () => import('@/views/user/profile_report'),
      },
      {
        name: 'user_vip',
        path: 'page/vip',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '会员中心' },
        component: () => import('@/views/user/vip.vue'),
      },
      {
        name: 'user_vip_config',
        path: 'page/vip/config',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '会员设置' },
        component: () => import('@/views/user/vip_config.vue'),
      },
      {
        name: 'user_game_config',
        path: ':game/config',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '' },
        component: () => import('@/views/user/game/game_config'),
      },
      {
        name: 'user_follower',
        path: 'follower',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '关注列表' },
        component: () => import('@/views/user/follower.vue'),
      },
      {
        name: 'user_find',
        path: 'find',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '找情缘或亲友' },
        component: () => import('@/views/user/find.vue'),
      },
      {
        name: 'user_matches',
        path: 'matches',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '筛选' },
        component: () => import('@/views/user/matches'),
      },
      {
        name: 'user_matches_result',
        path: 'matches/:game',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '扩列' },
        component: () => import('@/views/user/matches_result'),
      },
      {
        name: 'user_phone',
        path: 'phone',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '手机绑定' },
        component: () => import('@/views/user/phone.vue'),
      },
      {
        name: 'user_security',
        path: 'security',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '安全设置' },
        component: () => import('@/views/user/security.vue'),
      },
      {
        name: 'user_wechat',
        path: 'wechat',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '绑定微信' },
        component: () => import('@/views/user/wechat.vue'),
      },
      {
        name: 'user_couple',
        path: 'couple',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '我的绑定/CP' },
        component: () => import('@/views/user/couple.vue'),
      },
      {
        name: 'user_block',
        path: 'config/:type',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '黑名单设置' },
        component: () => import('@/views/user/block.vue'),
      },
      {
        name: 'user_share',
        path: 'share',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '分享给好友' },
        component: () => import('@/views/user/share.vue'),
      },
      {
        name: 'user_join',
        path: 'page/join',
        meta: { title: '加入海鳗，找人一起玩' },
        component: () => import('@/views/user/join.vue'),
      },
      {
        name: 'user_faq',
        path: 'faq/:type',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '常见问题解答' },
        component: () => import('@/views/user/faq.vue'),
      },
      {
        name: 'user_profile',
        path: 'profile',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '修改资料' },
        component: () => import('@/views/user/profile'),
      },
      {
        name: 'user_profile_avatar',
        path: 'profile/avatar',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '修改头像' },
        component: () => import('@/views/user/profile_avatar.vue'),
      },
      {
        name: 'user_game_select',
        path: 'game/select',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '游戏信息设置' },
        component: () => import('@/views/user/game/game-select.vue'),
      },
      {
        name: 'user_game_edit',
        path: 'game/:game/edit',
        meta: { auth: [AUTH_STATE.LOGGED_IN, AUTH_STATE.UNREGISTERED], title: '\u200e' },
        component: () => import('@/views/user/game/game-edit.vue'),
      },
      {
        name: 'user_config',
        path: 'config',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '设置' },
        component: () => import('@/views/user/config'),
      },
      {
        name: 'user_sign',
        path: 'sign',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '签到' },
        component: () => import('@/views/user/sign.vue'),
      },
      {
        name: 'user_admin_codes',
        path: 'admin/codes',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '兑换码管理' },
        component: () => import('@/views/discover/admin-code'),
      },
      {
        name: 'user_admin_stock',
        path: 'admin/stocks',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '导入库存' },
        component: () => import('@/views/discover/admin-stock'),
      },
      {
        name: 'user_admin_list',
        path: 'admin/list',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '管理员列表' },
        component: () => import('@/views/discover/admin-list.vue'),
      },
      {
        name: 'user_admin_options',
        path: 'admin/list/:type',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '管理员设置' },
        component: () => import('@/views/user/admin/options'),
      },
      {
        name: 'user_verify_approve_list',
        path: 'verify/approve',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '身份审核' },
        component: () => import('@/views/user/verify_approve_list.vue'),
      },
      {
        name: 'user_verify_approve_detail',
        path: 'verify/approve/:id',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '身份审核' },
        component: () => import('@/views/user/verify_approve_detail.vue'),
      },
      {
        name: 'user_verify',
        path: 'verify',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '认证' },
        component: () => import('@/views/user/verify.vue'),
      },
      {
        name: 'user_coin_log',
        path: 'coin',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '钱包' },
        component: () => import('@/views/user/coin/log.vue'),
      },
      {
        name: 'user_coin_topup',
        path: 'coin/topup',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '充值' },
        component: () => import('@/views/user/coin/topup.vue'),
      },
      {
        name: 'user_coin_withdraw',
        path: 'coin/withdraw',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '提现' },
        component: () => import('@/views/user/withdraw.vue'),
      },
      {
        name: 'user_medals',
        path: 'medals',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '我的成就' },
        component: () => import('@/views/user/medals'),
      },
      {
        name: 'user_field',
        path: 'field',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '用户数值' },
        component: () => import('@/views/user/field'),
      },
      {
        name: 'admin_tones_list',
        path: 'admin/tones/list',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '音鉴审核' },
        component: () => import('@/views/user/tones/admin-tones-list'),
      },
      {
        name: 'admin_tones_detail',
        path: 'admin/tones/detail-:id(\\d+)',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '音鉴审核' },
        component: () => import('@/views/user/tones/admin-tones-detail'),
      },
      {
        name: 'tones_index',
        path: 'tones',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '海鳗音鉴' },
        component: () => import('@/views/user/tones/index'),
      },
      {
        name: 'tones_detail',
        path: 'tones/detail-:id(\\d+)',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '海鳗音鉴' },
        component: () => import('@/views/user/tones/tones-detail'),
      },
      {
        name: 'tones_list',
        path: 'tones/list',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '音鉴历史' },
        component: () => import('@/views/user/tones/tones-list'),
      },
      {
        name: 'tones_identify',
        path: 'tones/identify',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '海鳗音鉴' },
        component: () => import('@/views/user/tones/tones-identify'),
      },
    ],
  },
] as RouteConfig[];
